import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Reusable news card (standard, hero, compact variants).
 */
const NewsCard = ({
  title,
  excerpt,
  image,
  meta,
  tags,
  badge,
  link = '/articolo',
  variant = 'standard',
}) => {
  const isUrl = image && (image.startsWith('http') || image.startsWith('/'));

  if (variant === 'hero') {
    return (
      <div className="card news-card news-card--hero">
        <div className="card__image" style={{ aspectRatio: '16/9', minHeight: 280, background: 'var(--color-surface-subtle)', position: 'relative', overflow: 'hidden' }}>
          {isUrl ? (
            <img src={image} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <div style={{ width: '100%', height: '100%', background: image || 'linear-gradient(135deg,#e27314,#b85a0f)' }} />
          )}
        </div>
        <div className="card__body">
          <div className="card__meta">
            {badge && <span className="badge badge--primary">{badge}</span>}
            {meta &&
              meta.map((m, i) => (
                <React.Fragment key={i}>
                  {i === 0 && badge && <span className="card__meta-dot"></span>}
                  {typeof m === 'string' ? <span>{m}</span> : m}
                  {i < meta.length - 1 && <span className="card__meta-dot"></span>}
                </React.Fragment>
              ))}
          </div>
          <h2 className="card__title">
            <Link to={link}>{title}</Link>
          </h2>
          {excerpt && <p className="card__excerpt">{excerpt}</p>}
          {tags && (
            <div className="tags mt-4">
              {tags.map((t) => (
                <span className={`tag${t.primary ? ' tag--primary' : ''}`} key={t.label}>
                  {t.label}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <article className="card news-card--compact">
        <div
          className="card__image"
          style={{
            width: 100,
            minWidth: 100,
            aspectRatio: '1',
            background: 'var(--color-surface-subtle)',
            borderRadius: 8,
            overflow: 'hidden'
          }}
        >
          {isUrl ? (
            <img src={image} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <div style={{ width: '100%', height: '100%', background: image || '#e27314' }} />
          )}
        </div>
        <div className="card__body">
          <div className="card__meta">
            {badge && <span className="badge badge--subtle">{badge}</span>}
            {meta &&
              meta.map((m, i) => (
                <span key={i}>{m}</span>
              ))}
          </div>
          <h4 className="card__title">
            <Link to={link}>{title}</Link>
          </h4>
        </div>
      </article>
    );
  }

  // Standard
  return (
    <article className="card news-card">
      <div
        className="card__image"
        style={{
          aspectRatio: '16/10',
          background: 'var(--color-surface-subtle)',
          overflow: 'hidden'
        }}
      >
        {isUrl ? (
          <img src={image} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ width: '100%', height: '100%', background: image || 'linear-gradient(135deg,#e27314,#b85a0f)' }} />
        )}
      </div>
      <div className="card__body">
        <div className="card__meta">
          {badge && <span className="badge badge--subtle">{badge}</span>}
          {meta &&
            meta.map((m, i) => (
              <React.Fragment key={i}>
                <span>{m}</span>
                {i < meta.length - 1 && <span className="card__meta-dot"></span>}
              </React.Fragment>
            ))}
        </div>
        <h4 className="card__title">
          <Link to={link}>{title}</Link>
        </h4>
        {excerpt && <p className="card__excerpt line-clamp-2">{excerpt}</p>}
      </div>
    </article>
  );
};

export default NewsCard;
